export enum TYPES {
  SET_MODAL = 'setModal',
  SET_MODAL_VISIBLE = 'setModalVisible',
}

export default TYPES
